import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import clsx from 'clsx'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Breakpoint from 'components/Common/Breakpoint'
import { mediaQueryUp } from 'components/utils/breakpoint'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import useIsHomepage from 'home/hooks/isHomepage'
import useIsOfferPage from 'hooks/Navigation/useIsOfferPage'
import useIsSearchPage from 'hooks/Navigation/useIsSearchPage'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { useWeddingGiftRegistryContext } from 'weddings/contexts/WeddingGiftRegistryContext'
import NavBarLoyaltyLogo from './NavBar/NavBarLoyaltyLogo'
import NavBarProducts from './NavBar/NavBarProducts'

const BarPane = styled(Pane)`
  width: 100%;
  display: none;

  &.show {
    display: block;
  }

  &:not(.hide) {
    &:not(.desktop-up) {
      ${mediaQueryUp.tablet} {
        display: block;
      }
    }

    &.desktop-up {
      ${mediaQueryUp.desktop} {
        display: block;
      }
    }
  }

`

const GlobalBar = styled(LayoutContainer)`
  height: ${rem(48)};
  padding-block: 0;
  padding-inline: ${rem(4)} ${rem(8)};
  display: flex;
  gap: ${rem(16)};
  justify-content: space-between;
  align-items: center;

  ${mediaQueryUp.desktop} {
    padding: 0 ${rem(16)};
  }

  ${mediaQueryUp.largeDesktop} {
    padding: 0 ${rem(20)};
  }
`

const ProductNavArea = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`

const LoyaltyNavArea = styled(Group)`
  flex: 0 0 auto;
  margin-inline-start: auto;
`

function NavBarGlobalBar() {
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const loyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const { isActive: isWeddingGiftRegistry } = useWeddingGiftRegistryContext()

  const isOfferPage = useIsOfferPage()
  const isSearchPage = useIsSearchPage()
  const isHomepage = useIsHomepage()

  return <BarPane
    className={clsx({
      // Homepage always shows the bar
      show: isHomepage || isWeddingGiftRegistry,
      // Global bar isn't shown on offer pages
      hide: isOfferPage,
      // Search shows it's own bar until desktop
      'desktop-up': isSearchPage,
    })}
  >
    <HorizontalContainerWithFadedOverflow overflowGutter={0}>
      <GlobalBar variant="extraLarge">
        <Breakpoint min="tablet">
          <ProductNavArea {...(isAgentHubEnabled ? { 'data-agent-hub-onboarding': 'products' } : {})}>
            <NavBarProducts />
          </ProductNavArea>
        </Breakpoint>
        <LoyaltyNavArea direction="horizontal" gap={16} verticalAlign="center">
          {loyaltyEnabled && !isAgentHubEnabled && <NavBarLoyaltyLogo variant="loyalty" />}
          {luxPlusEnabled && !isAgentHubEnabled && <NavBarLoyaltyLogo variant="luxPlus" />}
        </LoyaltyNavArea>
      </GlobalBar>
    </HorizontalContainerWithFadedOverflow>
  </BarPane>
}

export default NavBarGlobalBar
